// extracted by mini-css-extract-plugin
module.exports = {"container":"container___E353","paragraph":"paragraph__1snNO"};